<template>
    <div class="workScheduleFullyAssigned">
        <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M29.53 3.937a2.5 2.5 0 0 1 .771 3.45l-12.203 19.22c-1.353 2.25-4.553 2.332-6.041.248L1.985 16.107a2.5 2.5 0 1 1 3.649-3.419L14.8 22.47 26.08 4.707a2.5 2.5 0 0 1 3.45-.77z"
            />
        </svg>
        Er zijn geen werkindelingen om toe te wijzen.
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class FullyAssigned extends Vue {
    }
</script>

<style lang="scss" scoped>
    .workScheduleFullyAssigned {
        grid-column: span 2;
        position: sticky;
        left: 0;
        width: calc(100vw - 4rem);
        margin: .5rem 0;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            margin-right: var(--cell-padding);
            fill: var(--work-schedule-status-full);
        }
    }
</style>
